import { render, staticRenderFns } from "./DebugProperties.vue?vue&type=template&id=146b61e0&scoped=true&"
import script from "./DebugProperties.vue?vue&type=script&lang=js&"
export * from "./DebugProperties.vue?vue&type=script&lang=js&"
import style0 from "./DebugProperties.vue?vue&type=style&index=0&id=146b61e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146b61e0",
  null
  
)

export default component.exports